import { BaseApiService } from "../base";
import { STOModel } from "../../models/base/sto-model";
import { UserEmployeeActivityHistoryDTO } from "../../models/user-employee-activity-history";

export class EmployeeActivityApiService extends BaseApiService<UserEmployeeActivityHistoryDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/EmployeeActivity",
      loadItemsPath: "/GetEmployeeActivity",
    });
  }
}
